import { useQuery } from '@tanstack/react-query';
import { getCurrentUserProfile } from '@/features/profile/api/profileApi';
import { userManagementQueryKeys } from '@/features/settings/user-management/queryKeys';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';

export const useUserProfileQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  return useQuery({
    queryKey: userManagementQueryKeys.profile(),
    queryFn: () => getCurrentUserProfile(),
    staleTime: Infinity,
    enabled: publishedContext !== null ? false : enabled,
  });
};
